<template>
  <Dialog
    v-model:visible="model"
    modal
    :header="title"
    class="video-player-modal"
    :style="{ width: '50rem' }"
  >
    <div
      v-if="videoUrl"
      class="video-player-frame-wrapper"
    >
      <iframe
        :src="videoUrl"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      />
    </div>
    <p
      v-else
      class="tw:mb-0 text-muted"
    >
      Invalid YouTube link.
    </p>
  </Dialog>
</template>

<script setup lang="ts">
const model = defineModel({
  type: Boolean,
  required: true
})

defineProps<{
  videoUrl?: string
  title?: string 
}>()

</script>

<style lang="scss">
.video-player-modal {
  .p-dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .p-dialog-title {
      flex: 1;
      text-align: left;
    }
  }

  .video-player-frame-wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;

    iframe {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
